/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const AUTH = {
	LOGIN_FAILED_URL: "/",
	LOGIN_SUCCEED_URL: "/",
	DEFAULT_AUTH_PROVIDER_NAME: "adapptioOAuth",
	CHECK_TOKEN_BEFORE_EXPIRE_IN_SECONDS: 1800 // 30 minutes
};
